import Events from "../components/OrganizerEvents/Events";

const OrganizerEvents = () => {
  return <Events />;
};

export default OrganizerEvents;
